import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../../components/HeaderToolbar";
import EditIcon from "../../../Pages/Person/EditIcon";
import { getSiteTypeList } from "../../../slices/Site/SiteTypeSlice";
import { ThemeContext } from "../../../theme/ThemeContext";
import DeleteIcon from "../../Watchlist/DeleteIcon";
import AddSiteType from "./AddSiteType";
import DeleteSiteType from "./DeleteSiteType";
import FilterSiteType from "./FilterSiteType";
import SiteTypeViewDetails from "./SiteTypeViewDetails";

function SiteType() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDeleteSiteType, setOpenDeleteSiteType] = useState(false);
  const [siteTypeId, setSiteTypeId] = useState();
  const [siteTypeName, setSiteTypeName] = useState();
  const [openEditSiteType, setOpenEditSiteType] = useState(false);
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { setDiaLogBoxBlur } = useContext(ThemeContext);
  const [selectedObject, setSelectedObject] = useState({
    id: "",
    name: "",
    code: "",
    description: "",
  });

  const [filter, setFilter] = React.useState({
    id: "",
    name: "",
    code: "",
    description: "",
    isPagable: true,
    sort: "createdAt%7Cdesc",
    caseSensitive: false,
    operator: Boolean.AND,
  });

  const defaultFilter = {
    id: "",
    name: "",
    code: "",
    description: "",
    isPagable: true,
    sort: "createdAt%7Cdesc",
    caseSensitive: false,
    operator: Boolean.AND,
  };
  const applyFilter = (filterData) => {
    setClear(true);
    const query = {
      name: filterData.name,
      code: filterData.code,
      description: filterData.description,
    };

    setFilter({
      ...filter,
      ...query,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setPage(1);
    setFilter({
      ...defaultFilter,
    });
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    loadData(newPage, size);
    setRowsPerPage(size);
  };

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    loadData(1, rowsPerPage);
  }, [filter]);

  const loadData = (page, rowsPerPage) => {
    const payload = {
      filter: filter,
      page: page,
      rowsPerPage: rowsPerPage,
      Boolean: true,
    };

    dispatch(getSiteTypeList(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI6000" && data.data) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.currentPage);
          setRows(data.data.siteTypes);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      });
  };

  const handleEditSiteType = (params) => {
    setOpenEditSiteType(!openEditSiteType);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const handleDeleteSiteType = (params) => {
    setOpenDeleteSiteType(!openDeleteSiteType);
    setSiteTypeId(params.row.id);
    setSiteTypeName(params.row.name);
    setDiaLogBoxBlur(true);
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(page, rowsPerPage);
      setDel(false);
    } else {
      if (del === true) {
        loadData(page - 1, rowsPerPage);
        setDel(false);
      }
    }
  }, [del]);

  const handleTextOverflow = (text) => {
    if (text && text.length > 18) {
      return text.substring(0, 18) + "...";
    } else {
      return text;
    }
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "name",
      headerName: t("COMMON044"),
      flex: 1,
      width: 150,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.name}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.name)}</span>
        </Tooltip>
      ),
    },
    {
      field: "code",
      headerName: t("COMMON067"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.code,
    },
    {
      field: "description",
      headerName: t("STYPE009"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.description,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.description}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.description)}</span>
        </Tooltip>
      ),
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <div>
          <SiteTypeViewDetails rowData={params.row} />
        </div>,
        <Box onClick={() => handleEditSiteType(params.row)}>
          <EditIcon />
        </Box>,
        <Box onClick={() => handleDeleteSiteType(params)}>
          <DeleteIcon />
        </Box>,
      ],
    },
  ]);

  return (
    <>
      <HeaderToolbar title={t("STYPE001")} tooltipTitle={t("STYPE002")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "3px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("STYPE001")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item
            className="refreshIcon"
          >
            <RefreshIcon onClick={() => loadData(page, rowsPerPage)} />
          </Box>
        </Tooltip>
        <Box item>
          <FilterSiteType
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <AddSiteType
          open={open}
          selectedObject={selectedObject}
          handleClose={() => {
            loadData(page, rowsPerPage);
            setOpen(false);
            setDiaLogBoxBlur(false);
          }}
        />
      )}

      {openEditSiteType && (
        <AddSiteType
          selectedObject={selectedObject}
          open={openEditSiteType}
          handleClose={() => {
            setOpenEditSiteType(false);
            loadData(page, rowsPerPage);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              name: "",
              code: "",
              description: "",
            });
          }}
        />
      )}

      {openDeleteSiteType && (
        <DeleteSiteType
          open={openDeleteSiteType}
          handleClose={(data) => {
            setOpenDeleteSiteType(data);
            loadData(page, rowsPerPage);
            setDiaLogBoxBlur(false);
          }}
          delete={() => setDel(true)}
          DeleteSiteTypeId={siteTypeId}
          DeleteSiteTypeName={siteTypeName}
        />
      )}
    </>
  );
}

export default SiteType;
